import { DefaultApi } from 'src/api';
export const swagger = new DefaultApi();
